import { useEffect } from 'react';

/**
 * Hook that registers a global keyboard shortcut (Escape) ro close the player.
 *
 * @param onEscape - Callback function to execute when the shortcut is triggered
 */
export const useAudioEscapeShortcut = (onEscape: () => void): void => {
	useEffect(() => {
		const handleKeyDown = (e: KeyboardEvent) => {
			if (e.code === 'Escape') {
				e.preventDefault();
				onEscape();
			}
		};

		window.addEventListener('keydown', handleKeyDown);
		return () => window.removeEventListener('keydown', handleKeyDown);
	}, [onEscape]);
};
